import { mapGetters, mapActions, mapState } from 'vuex'
import TableEducationLevel from '@main/components/TableEducationLevel.vue'

export default {
  components: { TableEducationLevel },
  computed: {
    ...mapState('educationLevel', [
      'edu_forms',
      'generated_at',
      'campaign',
      'contest_groups',
      'total'
    ]),
    flatHeaders() {
      const getLeaves = (header) => {
        if (!header.items || !header.items.length) return [header];
        return header.items.flatMap(getLeaves);
      };
      return this.tableHeaders.flatMap(getLeaves);
    },
  },
  methods: {
    ...mapActions('educationLevel', ['getEducationLevel']),
    contestGroupRoute(id) {
      const { education_level, edu_form } = this.$route.params
      return {
        name: 'education_level_show',
        params: { education_level, edu_form, contest_group_id: id }
      }
    }
  },
}